/**
 * Handles all radios and checkboxes to be togglable with enter key
 * @module enterable
 */

import $ from 'jquery';
import Keyboard from './keyboard';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'enterable';
export const DEFAULTS = {

};
/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 */
const setEventListeners = ($el) => {
  $el.on('keydown.enterable', evt => {
    if (Keyboard.parseKey(evt) === Keyboard.keys.ENTER) {
      $el.trigger('click');
    }
  });
};
/**
 * Initializes enterable.
 * @param {HTMLElement} el - button /element that opens enterable
 * @see DEFAULTS
 */
export default function enterable(el) {
  const $el = $(el);
  setEventListeners($el);
}
registerJQueryPlugin(PLUGIN_NAME, enterable);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/enterable.js